import baseUrl from "./baseUrl";

function submitSubscription(data) {
  return {
    method: "post",
    url: `${baseUrl}/api/v1/dashboard/subscribeClub`,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  };
}

export default submitSubscription;
